module.exports = __webpack_public_path__ + "static/img/bg-Client-04.71022443.png";